import React, { forwardRef, InputHTMLAttributes } from 'react';

import styled from 'styled-components';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

interface StyledInputProps {}

const StyledInput = styled('input')<StyledInputProps>`
  border: 2px solid ${({ theme }) => theme.colors.gray_200};
  border-radius: 4px;
  height: 55px;
  outline: none;
  padding: 10px 20px;
  width: 100%;
  -webkit-user-select: text;

  ${({ theme }) => theme.fontTypes.type3}

  *::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.gray_500};
  }
  *:-moz-placeholder {
    /* FF 4-18 */
    color: ${({ theme }) => theme.colors.gray_500};
    opacity: 1;
  }
  *::-moz-placeholder {
    /* FF 19+ */
    color: ${({ theme }) => theme.colors.gray_500};
    opacity: 1;
  }
  *:-ms-input-placeholder {
    /* IE 10+ */
    color: ${({ theme }) => theme.colors.gray_500};
  }
  *::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${({ theme }) => theme.colors.gray_500};
  }
  *::placeholder {
    /* modern browser */
    color: ${({ theme }) => theme.colors.gray_500};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.gray_500};
  }
`;

// interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
//   ref?: { current: any };
// }

// const SearchInput = (props: SearchInputProps): ReactElement => <StyledInput {...props} />;

const SearchInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return <StyledInput ref={ref} {...props} />;
});

export default SearchInput;
